import { TimeRecord } from "@planzone/dto";
import { State } from "./types";

function matchRequest(req: State[number], timeRecord: TimeRecord): boolean {
  return (
    req.timeRecord.resource.uuid === timeRecord.resource.uuid &&
    req.timeRecord.task.uuid === timeRecord.task.uuid
  );
}

export { matchRequest };
